import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createNeurosurgeryDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterNeurosurgeryFormSchema } from "./schema";
import { DischargeLetterNeurosurgeryFormSections } from "./sections";

export const getDischargeLetterNeurosurgeryFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_NEUROSURGERY
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => ({
      additional_diagnostic_findings:
        value?.additional_diagnostic_findings ?? "",
      admission_medications: value?.admission_medications ?? "",
      allergies: value?.allergies ?? "",
      anamnesis: value?.anamnesis ?? "",
      appointments: value?.appointments ?? "",
      clinical_course: value?.clinical_course ?? "",
      diagnoses: value?.diagnoses ?? "",
      discharge_medications: value?.discharge_medications ?? "",
      ecg: value?.ecg ?? "",
      lab_results: value?.lab_results ?? "",
      laboratory_parameters: value?.laboratory_parameters ?? "",
      parameters: value?.parameters ?? "",
      physical_status: value?.physical_status ?? "",
      recommendations: value?.recommendations ?? "",
      social_anamnesis: value?.social_anamnesis ?? "",
      therapy: value?.therapy ?? "",
    }),
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf
          .savedFileNameNeuroSurgery,
      pdfCreator: createNeurosurgeryDischargeLetterPdf,
    },
    schema: DischargeLetterNeurosurgeryFormSchema,
    sections: DischargeLetterNeurosurgeryFormSections,
  };
};
